module.exports = __webpack_public_path__ + "static/media/3cfa0cca-db75-4502-aceb-b2f32d5b843e.2a605f84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/3cfa0cca-db75-4502-aceb-b2f32d5b843e.png
// module id = 1486
// module chunks = 0